<script>
import {
  doc,
  updateDoc,
  getFirestore,
  serverTimestamp,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

export default {
  name: "StrappEditProfile",

  data() {
    return {
      checked: false,
      interest_count: 0,
      avatar: { imageURL: this.$store.state.user.avatar },
      firstName: this.$store.state.user.firstName,
      bio: this.$store.state.user.bio,
      suburb: this.$store.state.user.suburb,
      user_interests: this.$store.state.user.interests,
      user_data: this.$store.state.user,
      selected: "",
      interests: [
        { name: "Film & Photography", checked: false, disabled: false },
        { name: "Audio Visual Equipment", checked: false, disabled: false },
        { name: "Projectors and Screens", checked: false, disabled: false },
        { name: "Drones", checked: false, disabled: false },
        { name: "DJ Equipment", checked: false, disabled: false },
        { name: "Transport", checked: false, disabled: false },
        { name: "Storage", checked: false, disabled: false },
        { name: "Electronics", checked: false, disabled: false },
        { name: "Party and Events", checked: false, disabled: false },
        { name: "Sports", checked: false, disabled: false },
        { name: "Music", checked: false, disabled: false },
        { name: "Home, Office and Garden", checked: false, disabled: false },
        { name: "Kids and Baby", checked: false, disabled: false },
        { name: "Holiday and Travel", checked: false, disabled: false },
        { name: "Clothing", checked: false, disabled: false },
      ],
      selectedInterests: [],
      uploading: false,
      downloadURL: "",
    };
  },

  components: {
    Loader: () => import("@/components/Loader.vue"),
    ImageInput: () => import("@/components/Profile/ImageInput.vue"),
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
  },

  methods: {
    async updateProfile() {
      this.uploading = true;
      console.log("Bio:", this.bio);
      console.log("Suburb", this.suburb);
      console.log("Avatar", this.avatar.imageURL);
      console.log("SelectedInterests", this.selectedInterests);
      const db = getFirestore();

      const userRef = doc(db, "users", "QfQD63uSB4OFS7G756JbpjYhsUb2");

      for (let i = 0; i < this.interests.length; i++) {
        if (this.interests[i].checked) {
          this.selectedInterests.push(this.interests[i].name);
        }
      }

      if (this.avatar.imageFile) {
        console.log("uploading avatar");
        const storage = getStorage();
        const storageRef = ref(
          storage,
          "users/" + this.$store.getters.user.id + "/" + "avatar"
        );
        // const uploadTask = uploadBytesResumable(storageRef, this.avatar);
        const snapshot = await uploadBytes(
          storageRef,
          this.avatar.imageFile
        ).then((snapshot) => {
          console.log("Uploaded a blob or file!");
          //get downloadURL of the uploaded file
          return snapshot;
        });

        this.downloadURL = await getDownloadURL(snapshot.ref);
      } else if (!this.avatar.imageFile && this.avatar.imageURL) {
        this.downloadURL = this.avatar.imageURL;
      } else if (!this.avatar.imageFile && !this.avatar.imageURL) {
        this.downloadURL = "";
      }

      console.log("downloadURL", this.downloadURL);

      await updateDoc(userRef, {
        bio: this.bio,
        suburb: this.suburb,
        interests: this.selectedInterests,
        avatar: this.downloadURL,
        updatedAt: serverTimestamp(),
      })
        .then(() => {
          this.$store.dispatch("updateUserProfile", {
            bio: this.bio,
            suburb: this.suburb,
            interests: this.selectedInterests,
            avatar: this.downloadURL,
          });
        })
        .then(() => {
          this.uploading = false;
          //show toast
          Toast.fire({
            title: "Profile updated successfully",
          });
          this.$router.push("/dashboard");
        });

      //toast popup
    },

    interest_increase: function (interest) {
      //changing the value of checked to add the blue class, with this class I add
      // the background color to the button as if it was active.
      interest.checked = !interest.checked;

      if (interest.checked) {
        this.interest_count++;
      } else {
        this.interest_count--;
        ``;
      }
    },
    getInterests() {
      // change the interests from interest_options to checked if they ar in the this.$store.getters.user.interests array
      for (let i = 0; i < this.interests.length; i++) {
        for (let j = 0; j < this.user.interests.length; j++) {
          if (this.interests[i].name == this.user.interests[j]) {
            this.interests[i].checked = true;
            this.interest_count++;
          }
        }
      }
    },
  },
  mounted() {
    console.log("user user", this.$store.getters.user);

    // change the interests from interest_options to checked if they ar in the this.$store.getters.user.interests array
    for (let i = 0; i < this.interests.length; i++) {
      for (let j = 0; j < this.user_interests.length; j++) {
        if (this.interests[i].name == this.user_interests[j]) {
          this.interests[i].checked = true;
          this.interest_count++;
        }
      }
    }
  },

  watch: {
    user(newValue) {
      console.log("NEW VALUE", newValue);
      //if data is not null
      if (this.firstName == null) {
        if (newValue !== null) {
          console.log("HERE");
          //set data properties from user
          this.firstName = newValue.firstName;
          this.bio = newValue.bio;
          this.suburb = newValue.suburb;
          this.avatar.imageURL = newValue.avatar;
          this.user_interests = newValue.interests;
          this.user_data = newValue;
        } else if (newValue == null) {
        }
      }
    },
    user_interests(newValue) {
      console.log("you're watching me");
      if (newValue.length > 0) {
        console.log("run it up");
        this.getInterests();
      }
    },
    interest_count: function (n, o) {
      if (this.interest_count > 4) {
        for (let i = 0; i < this.interests.length; i++) {
          if (!this.interests[i].checked) {
            this.interests[i].disabled = true;
          } else {
            this.interests[i].disabled = false;
          }
        }
      } else {
        for (let i = 0; i < this.interests.length; i++) {
          this.interests[i].disabled = false;
        }
      }
    },
  },
};
</script>
<template>
  <div>
    <!-- <div v-if="!this.firstName" class="grid">
      <loader />
    </div> -->

    <div class="grid mt-8 ma-2">
      <v-col class="d-flex align-start" cols="12" md="8" lg="6">
        <v-row class="d-flex justify-space-between mb-auto">
          <v-col cols="8">
            <p class="text-h4">Edit Profile</p>
          </v-col>
          <v-col>
            <v-row class="justify-space-between">
              <v-col>
                <v-btn
                  to="/dashboard"
                  rounded
                  depressed
                  :disabled="uploading"
                  block
                  class="mr-3 font-weight-light"
                >
                  Cancel
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  @click="updateProfile()"
                  rounded
                  depressed
                  :loading="uploading"
                  block
                  color="app lighten-3 white--text"
                  opacity=".6"
                  class="font-weight-light"
                >
                  Save
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="8" lg="6">
        <v-row>
          <v-divider></v-divider>
        </v-row>
      </v-col>

      <v-col cols="12" md="8" lg="6">
        <v-avatar size="150">
          <v-img
            v-if="this.avatar.imageURL"
            :src="`${this.avatar.imageURL}`"
            alt="People"
          />

          <svg
            v-else
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
            style="fill: currentcolor"
            aria-hidden="true"
            role="presentation"
            focusable="false"
          >
            <path
              d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
            ></path>
          </svg>
        </v-avatar>
      </v-col>

      <v-col cols="12" md="8" lg="6">
        <v-row class="my-4">
          <image-input v-model="avatar">
            <div slot="activator">
              <v-btn
                rounded
                depressed
                block
                color="app lighten-3 white--text"
                opacity=".6"
                class="font-weight-light"
              >
                <span>Click to change avatar</span>
              </v-btn>
            </div>
          </image-input>
        </v-row>
      </v-col>

      <v-col cols="12" md="8" lg="6">
        <v-row>
          <v-col cols="12" md="10">
            <div class="my-2">A few words about yourself</div>
            <v-textarea
              class="round"
              v-model="bio"
              name="value"
              outlined
              style="border-radius: 12px"
              required
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="8" lg="6">
        <v-row>
          <v-col cols="12" md="8">
            <div class="my-2">Your city</div>
            <v-text-field
              class="round"
              v-model="suburb"
              name="value"
              outlined
              style="border-radius: 12px"
              required
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="8" lg="6">
        <v-row>
          <v-col cols="8" md="8">
            <div>
              Update your preferences
              <br />
              {{ this.interest_count }}/5
            </div>
          </v-col>
        </v-row>
        <v-row>
          <div class="interests__content text-left">
            <transition-group>
              <v-tooltip
                color="#AB47BC"
                top
                v-for="interest in interests"
                :key="interest.name"
              >
                <template v-slot:activator="{ props }">
                  <v-btn
                    v-model="selected"
                    v-bind="props"
                    outlined
                    style="border-radius: 8px"
                    slot="activator"
                    :class="{
                      material: interest.checked,
                      interest__btn: !interest.checked,
                    }"
                    class="ma-1"
                    @click="interest_increase(interest)"
                    :disabled="interest.disabled"
                    :checked="checked"
                    >{{ interest.name }}</v-btn
                  >
                </template>
              </v-tooltip>
            </transition-group>
          </div>
        </v-row>
      </v-col>
      <v-col cols="12" md="8" lg="6">
        <v-row class="d-flex align-start mt-5">
          <v-col cols="4">
            <v-btn
              @click="updateProfile()"
              rounded
              depressed
              :loading="uploading"
              block
              color="app lighten-3 white--text"
              opacity=".6"
              class="font-weight-light"
            >
              Save
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn
              to="/dashboard"
              rounded
              depressed
              :disabled="uploading"
              block
              class="mr-3 font-weight-light"
            >
              Cancel
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
